import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import { EmptyContainer, EmptyText } from "@/components/styling/empty";
import { MDSButton, MDSIcon, MDSButtonSlotName, MDSIconKind } from "@/mds";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { observer } from "mobx-react-lite";

interface SearchPageNotesListEmptyProps {
  query: string;
  isSuccess: boolean;
  anyFiltersSelected: boolean;
  onRetryClick: () => void;
}

export const SearchPageNotesListEmpty = observer(
  ({
    query,
    isSuccess,
    anyFiltersSelected,
    onRetryClick,
  }: SearchPageNotesListEmptyProps): JSX.Element => {
    const page = useTabPageStore("searchPage");
    return (
      <EmptyContainer>
        <EmptySearchImage />
        <EmptyText>{getEmptyText(query, isSuccess, anyFiltersSelected)}</EmptyText>
        {!isSuccess && (
          <MDSButton onClick={onRetryClick}>
            <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.Redo} />
            Retry
          </MDSButton>
        )}
        {anyFiltersSelected && isSuccess && (
          <MDSButton onClick={() => page.filters.clearAllFilters()}>Clear filters</MDSButton>
        )}
      </EmptyContainer>
    );
  }
);

const getEmptyText = (query: string, isSuccess: boolean, anyFiltersSelected: boolean): string => {
  if (!isSuccess) {
    return getErrorText(query);
  }

  if (anyFiltersSelected) {
    return "No results match your selected filters";
  }

  if (query) {
    return "No results for " + `"${query}"`;
  }

  return "No results match your search";
};

const getErrorText = (query: string): string => {
  if (query) {
    return "Could not load results for " + `"${query}"`;
  }

  return "Could not load results";
};
